import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type Props = {
  breakpoint: number;
  children: React.ReactNode;
};

export const ToolbarButtonGroup = ({ breakpoint, children }: Props) => (
  <div
    css={css`
      display: inline-flex;
      column-gap: ${theme.spacing(0.5)};
      @media (max-width: ${breakpoint}px) {
        display: none;
      }
    `}
  >
    {children}
  </div>
);
